<template>
  <Popper
    :color-scheme="colorScheme"
    :title="title"
    :placement="placement"
    :hide-icon="hideIcon"
    :quick="quick"
  >
    <slot />
  </Popper>
</template>

<script>
import Popper from '@/components/Popper.vue';

export default {
  name: 'InfoTooltip',
  components: {
    Popper,
  },
  props: {
    colorScheme: {
      type: String,
      required: false,
      default: 'dark',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    placement: {
      type: String,
      required: false,
      default: 'top',
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    quick: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
:root {
  --popper-theme-background-color: #333333;
  --popper-theme-background-color-hover: #333333;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 32px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>
